import partner from '../../fields/other/partner';

export const QUERY_GET_ALL_PARTNERS = /* GraphQL */ `
	query($filter: PartnerUpdate) {
		getAllPartners(filter: $filter) {
			${partner}
		}
	}
`;
